import Vue from 'vue';
import VueImg from 'v-img';

import empty from 'locutus/php/var/empty';
import Pusher from 'pusher-js';

import 'iframe-resizer/js/iframeResizer.contentWindow';

import App from './App.vue';
import Global from './mixins/Global.js';
import router from './router/index.js';
import store from './store/index.js';

// Plugins
import NioUI from './plugins/nio-ui.js';
import VueModal from './plugins/vue-modal.js';
import VueTippy from './plugins/vue-tippy.js';
import VueEventBus from './plugins/vue-event-bus.js';
import VueConfigs from './plugins/vue-configs.js';
import i18n from './plugins/vue-i18n.js';
import wait from './plugins/vue-wait.js';
import moment from './plugins/moment.js';
import './plugins/broadcasting.js';
import './plugins/axios.js';
import './plugins/optimizely.js';
import './plugins/errors.js';
import './plugins/sentry.js';
import './plugins/filters.js';
import './plugins/vue-mq.js';
import './plugins/svg-icons.js';

// Styles
import './assets/css/app.css';

window.empty = empty;
window.Pusher = Pusher;
window.moment = moment;

// Vue init
Vue.config.productionTip = false;

Vue.use(NioUI);
Vue.use(VueImg);
Vue.use(VueModal);
Vue.use(VueTippy);
Vue.use(VueEventBus);
Vue.use(VueConfigs);

Vue.mixin(Global);

new Vue({
    i18n,
    router,
    store,
    wait,
    render: h => h(App),
}).$mount('#app');
